import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Users from './Users';
import GroupForm from './GroupForm';
import UserForm from './UserForm';

const UsersRouter = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={Users} />
    <Route exact path={`${match.url}/new/:id?`} component={UserForm} />
    <Route exact path={`${match.url}/group/:id?`} component={GroupForm} />
  </Switch>
);

export default UsersRouter;
